import React, { Component } from "react";
import { connect } from "react-redux";
import DynamicList from "components/UI/DynamicList";
import config from "config/api";
import { getCurrentUserRole } from "components/UI/Account/ducks/authentication";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { withRouter } from "react-router-dom";
// import { fetchData, getDataHome, getLoadingError } from 'ducks/asyncFetcher';
import { getDataHome } from 'ducks/asyncFetcher';

class AdminUtmList extends Component {
  render() {
    const { userRole } = this.props;
    const moduleConfig = {
      module: "event",
      fetchUrl: config.utm + "/list",
      deleteUrl: config.utm + "/delete",
      editUrl: "staff/utm/edit",
    };
    return (
      <div>
        <If condition={userRole === "admin" || userRole === "staff"}>
          <Box align="center" mt={3} mb={2} px={2}>
        <Typography variant="h2" gutterBottom>UTMs</Typography>
          <Button variant="contained" color="primary" onClick={(e) => {e.preventDefault(); this.props.history.push("/staff/utm/edit")}}>Ajouter</Button>
          </Box>
        </If>
        <DynamicList moduleConfig={moduleConfig} />
      </div>
    );
  }
}

function mapStateToProps(state) {
  const props = {
    $$data: getDataHome(state),
    userRole: getCurrentUserRole(state),
  };
  return props;
}

export default withRouter(connect(mapStateToProps)(AdminUtmList));



// WEBPACK FOOTER //
// ./src/components/UI/Utm/AdminUtmList.jsx